module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/cycling-7d62650bfb187285755cd03ed7bed0ad.png";